module.exports = __webpack_public_path__ + "img/role01.0fbd0c60.png";